module.exports = __webpack_public_path__ + "img/VP-Standard-Info.bb73961b.jpg";